import React from 'react'
import './ProductsItem.scss'
import { Link } from 'react-router-dom'

import Wirerod from '../../../assets/Pictures/Products/wirerod.jpg'
import Steelrebar from '../../../assets/Pictures/Products/steelrebar.jpg'
import StandardsGalvanizedWire from '../../../assets/Pictures/Products/Alambre-Galvanizado.jpg'
import Steelignot from '../../../assets/Pictures/Products/Steelignot.jpg'
import EPIndustrialCooler from '../../../assets/Pictures/Products/EP-Industrial-cooler.jpg'

export default function ProductsItem() {
  return (
    <div className='productsItem'>
      <div className='container'>
        <div className='row'>
          <div className='product'>
            <Link to='/tr/wirerod' className="item">
              <img src={Wirerod} alt="Wirerod" />
              <div className="text">
                FILMAŞIN
              </div>
            </Link>
            <Link to='/tr/steelrebar' className="item">
              <img src={Steelrebar} alt="Wirerod" />
              <div className="text">
                ÇELIK İNŞAAT DEMIRI
              </div>
            </Link>
            <Link to='/tr/standardgalvanizedwire' className="item">
              <img src={StandardsGalvanizedWire} alt="Wirerod" />
              <div className="text">
               STANDART GALVANİZ TEL
              </div>
            </Link>
            <Link to='/tr/steelingot' className="item">
              <img src={Steelignot} alt="Wirerod" />
              <div className="text">
                ÇELİK KÜLÇE ( KÜTÜK )
              </div>
            </Link>
          </div>
          <div className='product' style={{ justifyContent: 'right', marginTop: '1em' }}>
            <Link to='/tr/EPIndustrialCooler' className="item">
              <img src={EPIndustrialCooler} alt="Wirerod" />
              <div className="text">
                EP Industrial cooler
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
